import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Form from '~/commons/components/form';
import Fetchable from '~/commons/components/util/Fetchable';
import PageMascots from '../PageMascots';

const PageProfileMascot = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Fetchable req={{ url: '/api/users/self' }}>
      {({ mascot } = {}) => (
        <Form
          defaults={{ mascot: null }}
          stored={{ mascot: mascot?._id }}
          api={{ url: '/api/users/self', method: 'PATCH' }}
          onSubmitted={() => navigate('/game/profile')}
        >
          {({ values, setValues }) => (
            <PageMascots
              title={t('pg.game.mascot')}
              initValue={values.mascot}
              onChange={(m) => setValues({ mascot: m })}
            >
              <div className="text-center">
                <Form.BtnSubmit
                  icon={null}
                  className="btn-rock-3 fontBorder"
                >
                  {t('confirm', 'Confirm')}
                </Form.BtnSubmit>
              </div>
            </PageMascots>
          )}
        </Form>
      )}
    </Fetchable>
  );
};

export default PageProfileMascot;
